// ============================================================================
// supportRenderer.tsx — ПРИЛОЖЕНИЕ «Поддержка» (appKind/code 'support'): точка
// входа ИНБОКСА ОБРАЩЕНИЙ (§3.4) в оболочке «Предприятие».
//
// Рендерер регистрируется КЛИЕНТОМ (реестр приложений): приложение открывается
// из дока/«Пуска» без серверного объекта kind='app' — код резолвится
// getAppRendererByCode, манифест лишь уточняет имя/область. Роль определяет
// РЕЖИМ страницы: специалист поддержки/админ — полный инбокс (фильтры,
// назначение, статусы, ответы, шаблоны), обычный пользователь — «Мои обращения»
// (сервер отдаёт только его обращения, управляющие действия скрыты).
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { SupportInboxPage } from '@/pages/SupportInboxPage';
import { SUPPORT_APP_CODE, isSupportStaff } from '@/lib/supportInbox';
import { useSecurityAccess } from '@/lib/securityRoles';

function SupportApp() {
  const access = useSecurityAccess();
  return <SupportInboxPage isStaff={isSupportStaff(access)} />;
}

/** Манифест приложения поддержки (AppHost): системное, на весь воркспейс. */
export const SUPPORT_INBOX_MANIFEST: AppManifest = {
  code: SUPPORT_APP_CODE,
  name: SUPPORT_APP_CODE,
  synonym: 'Поддержка',
  appKind: SUPPORT_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['data:read'],
};

export function registerSupportInboxApp(): void {
  registerAppRenderer({
    appKind: SUPPORT_APP_CODE,
    code: SUPPORT_APP_CODE,
    title: 'Поддержка',
    Component: SupportApp,
    manifest: SUPPORT_INBOX_MANIFEST,
  });
}
